import {
  DATASTRATEGY,
  IEntity,
  STORAGESTRATEGY,
} from '@proximus/entity-manager';
import { SessionStorageStrategy } from '@proximus/entity-manager/lib/storage/strategies/session-storage.strategy';

export const ProductsEntity: IEntity<any> = {
  url: '/rest/products-aggregator/user-product-overview{?includeOptions,includePromos,appBrand,includePayingOptionsForFlsUr,refreshCache}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pa:userproductoverview',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: STORAGESTRATEGY.NONE,
};

export const MobileProductDetailsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/mobile/{serviceId}/details/basic{?appBrand,includePayingOptionsForFlsUr,includePayingSubscriptionsForFlsUr}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:mobileproductsbasic',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const OptionDetailsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/{optionId}/optionDetails?dummy={customerId}{&appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:optiondetails',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const TelephonyProductDetailsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/telephony/{serviceId}/details/basic{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:telephonyproductsbasic',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const EBUMobileProductDetailsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/mobile/{serviceId}/details/ebu{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:mobileproductebu',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const TvProductDetailsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/tv/{serviceId}/details/basic{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:tvproductsbasic',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const InternetProductDetailsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/internet/{serviceId}/details/basic{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:internetproductsbasic',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const DigitalisProductDetailsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/digitalis/{serviceId}/details{?includeSelector,appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:digitalisproducts',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const MobileProductAvailableOptionsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/mobile/{serviceId}/details/availableoptions{?categories,appBrand,includePayingOptionsForFlsUr}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:mobileproductsavailableoptions',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const TelephonyProductAvailableOptionsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/telephony/{serviceId}/details/availableoptions{?categories,appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:telephonyproductsavailableoptions',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const TvProductAvailableOptionsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/tv/{serviceId}/details/availableoptions{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:tvproductsavailableoptions',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const InternetProductAvailableOptionsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/internet/{serviceId}/details/availableoptions{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:internetproductsavailableoptions',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const MobileProductAvailableSettingsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/mobile/{serviceId}/details/availablesettings{?appBrand,includePayingOptionsForFlsUr}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:mobileproductsavailablesettings',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const MobileProductAvailableSubscriptionsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/mobile/{serviceId}/details/availablesubscriptions{?appBrand,includePayingSubscriptionsForFlsUr}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:mobileproductsavailablesubscriptions',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const DeepLinkOptionDetailsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/{mpcUuid}/optionDetails{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:optiondetails',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const EPressProductDetailsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/products/epress/{serviceId}/details{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pda:epressproducts',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const ExceedingAmountEntity: IEntity<any> = {
  url: '/rest/unbilled-balance/unbilled-balance{?bone,mcs,telephony,tv}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'ubl:unbilledBalances',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const SimInfoEntity: IEntity<any> = {
  url: '/rest/product-info-mobile/products/mobile/{msisdn}/siminfo',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pim:siminfo',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.STORAGE_PROXY,
  storageStrategy: SessionStorageStrategy.ID,
};

export const OptionGroupsConfigEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'optionGroupsConfig',
  url: '/dam/cdn/static/webResources/myProducts/{segment}/optionGroups.json',
  version: 'v1',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const OptionsCategoriesConfigEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'optionsCategoriesConfig',
  url: '/dam/cdn/static/webResources/myProducts/{segment}/optionsCategories.json',
  version: 'v1',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const updateMPayThreshold: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: true,
  rel: 'po:configureoption',
  url: '/rest/product-options/product/configuration',
  version: 'v1',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const deleteMandate: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: true,
  rel: 'mop:optoutservices',
  url: '/rest/mobile-payments/customer/optOutServices',
  version: 'v1',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const SettingsCategoriesConfigEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'settingsCategoriesConfig',
  url: '/dam/cdn/static/webResources/myProducts/{segment}/settingsCategories.json',
  version: 'v1',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const FreeVodConfigEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'freeVodConfig',
  url: '/dam/cdn/static/webResources/myProducts/{segment}/freeVod.json',
  version: 'v1',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const OptionLockConfigEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'po:optionlock',
  url: '/rest/product-options/product/{plc}/{serviceId}/option/{optionMpcUuid}/lock{?appBrand}',
  version: 'v1',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const OptionConfigurationLockConfigEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'po:optionconfigurationlock',
  url: '/rest/product-options/product/{plc}/{serviceId}/option/{optionMpcUuid}/configurationLock{?appBrand}',
  version: 'v1',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const UpdatePrepaidSettingsEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'prepaid_settings:updatePrepaidThreshold',
  url: '/rest/prepaid-settings/prepaidSettings/{msisdn}/threshold',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const UpdatePrepaidSettingsMsisdnEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'prepaid_settings:updatePrepaidSettings',
  url: '/rest/prepaid-settings/prepaidSettings/{msisdn}',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const AvailableSpeedEntity: IEntity<any> = {
  requestHeaders: ['customHeaders'],
  disableCache: false,
  secure: false,
  rel: 'pc:monitored-speed',
  url: '/rest/bwt-product-check/monitoredSpeed/{serviceId}',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.STORAGE_PROXY,
  storageStrategy: SessionStorageStrategy.ID,
  customHeaders: {
    'x-caller-chain': 'MPRD',
  },
};

export const UpdateInternetPasswordEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'psi:updateinternetpassword',
  url: '/rest/product-settings-internet/updatepassword',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const GetModemSafetySettingsEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'psi:getModemSafetySettings',
  url: '/rest/product-settings-internet/login/{loginId}/settings',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const GetWifiSsidEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'psi:getwifissid',
  url: '/rest/product-settings-internet/products/internet/{accessNumber}/settings/wifissid',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const UpdateWifiSsidEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'psi:updatewifissid',
  url: '/rest/product-settings-internet/products/internet/{accessNumber}/settings/wifissid',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const UpdateModemSafetySettingsEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'psi:updateModemSafetySettingsEntity',
  url: '/rest/product-settings-internet/updateconnectionsecurity',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const UpdateSharedIpSettingsEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'psi:updateSharedIpSettingsEntity',
  url: '/rest/product-settings-internet/cgnsetting',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const GetNetflixWebToken: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'pda:webTokenNetflix',
  url: '/rest/products-detail-aggregator/products/tv/webTokenNetflix',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: SessionStorageStrategy.ID,
};

export const GetDisneyPlusWebToken: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'pda:jwtDisneyPlus',
  url: '/rest/products-detail-aggregator/products/tv/{serviceId}/jwtDisneyPlus{?token}',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: SessionStorageStrategy.ID,
};

export const ProductAttributesEntity: IEntity<any> = {
  url: '/rest/products/new/productAttributes',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pro:attrsByMpcUuid',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const ProductPriceEntity: IEntity<any> = {
  url: '/rest/prices/WEB/price/validity/{mpcUuid}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pri:product_price',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const ProductPricePackEntity: IEntity<any> = {
  url: '/rest/prices/WEB/price/bundle/validity/{mpcUuid}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'pri:bundle_price',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const WifiInformationEntity: IEntity<any> = {
  url: '/rest/home-gateway/customers/{customerId}/modem/hgw4/{circuitId}/wifi',
  requestHeaders: [],
  rel: 'mhgw:get-wifi-information',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const OffersEntity: IEntity<any> = {
  url: '/rest/offers/offers/WEB_MYPX',
  requestHeaders: [],
  rel: 'of:offers',
  version: 'v2',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const GetDisneyPlusDetails: IEntity<any> = {
  requestHeaders: ['language'],
  secure: false,
  rel: 'pda:bcgTokenDisneyBuyAndSell',
  url: '/rest/products-detail-aggregator/products/tv/bcgTokenDisneyBuyAndSell{?token}',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const CryptoJointOfferRenewalEncryption: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  url: '/rest/crypto/encryptMessage?encryptionKey={encryptionKey}&keyDecoder=BASE64&encryptionAlgorithm=AES_CBC',
  version: 'v1',
  rel: 'crypto/encryptMessage',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const GetCodeGeneratorEntity: IEntity<any> = {
  url: '/rest/crypto/code-generator',
  version: 'v1',
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
  requestHeaders: ['customHeaders'],
  customHeaders: {
    Accept: 'application/vnd.pxs.bcg_token.v2+json',
    'x-caller-chain': 'myProducts',
  },
};

export const SplitUnbilledBalanceEntity: IEntity<any> = {
  url: '/rest/unbilled-balance/unbilled-balance/splitUnbilledBalance/service/{serviceId}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'ubl:splitUnbilledBalance',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const MacIpAddressEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'psi:macipaddress',
  url: '/rest/product-settings-internet/products/internet/{circuitId}/settings/macipaddress',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: SessionStorageStrategy.ID,
};

export const SettingsCtaFilterConfigEntity: IEntity<any> = {
  requestHeaders: [],
  disableCache: false,
  secure: false,
  rel: 'settingsCtaFilterConfig',
  url: '/dam/cdn/static/webResources/myProducts/{segment}/settingsCtaFilter.json',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};
